define [], () ->
  (RENTAPPLICATION_API_URL, $scope, $uibModalInstance, RentappService, all_questions_and_answers, context, $http) ->
    $scope.all_questions_and_answers = all_questions_and_answers
    $scope.submit_answers = () ->
      $scope.submitting_answers = true
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/reportsourceprofile/experian_questions/?#{context}=true",
        answers: $scope.all_questions_and_answers.map (q_and_a) -> q_and_a.answer
      .then (response) ->
        $uibModalInstance.close()
      .catch (response) ->
        $uibModalInstance.dismiss("failure")
      .finally -> $scope.submitting_answers = false

    $scope.close_modal = () ->
      $uibModalInstance.dismiss("failure")




// WEBPACK FOOTER //
// ./services/experian/experianQuestions/experianQuestions.coffee